import React from 'react'
import './styles.scss'
import { Box, Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

const AboutUsFourthComponent = () => {
    return (
        <Box className="AboutUsFourthComponentWrapper">
            <Typography variant='h2' className='AboutUsFourthComponentTitle'>
                What's holding you back?
            </Typography>
            <Typography variant='h3' className='AboutUsFourthComponentSubTitle'>
                Initiate the protection of your digital service today.
            </Typography>
            <Link to='/signin' className='AboutUsFourthComponentLink'>
                <Button className='AboutUsFourthComponentButton'>
                    Contact Us
                </Button>
            </Link>
        </Box>
    )
}

export default AboutUsFourthComponent